import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { Setor } from "./setor.model";

@Injectable()
export class SetorApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Setor, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Setor, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"setor","include":"divisao"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":["divisao"]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/shared/setor-api.service.ts
 **/